const actions = {
  FETCH_REFERENCE_IMAGES: "FETCH_REFERENCE_IMAGES",
  VIEW_REFERENCE_IMAGE: "VIEW_REFERENCE_IMAGE",
  LOAD_SITE_LIST: "LOAD_SITE_LIST",
  LOAD_CAMERA_LIST: "LOAD_CAMERA_LIST"
};

export default actions;
